import type { QBankStructureStatus } from '@exam-management/graphql';
import { type LabelProps, Label } from '@shared/components';

import { QBS_COLOR_STATUS, QBS_STATUS_TEXT } from './constants';

export interface QBankStructureStatusTagProps extends LabelProps {
  status: QBankStructureStatus;
}

export default function QBankStructureStatusTag(props: Readonly<QBankStructureStatusTagProps>) {
  const { status, ...restProps } = props;

  return (
    <Label color={QBS_COLOR_STATUS[status]} variant='outlined' {...restProps}>
      {QBS_STATUS_TEXT[status]}
    </Label>
  );
}
